export const permissions = {
  general: {
    QUEUE_MONITORING: {
      VIEW: 'ccpro/general/queueMonitoring/queues:view',
      AGENT_ACTIVITY_VIEW: 'ccpro/general/queueMonitoring/agentActivity:view',
      AGENT_ACTIVITY_EDIT: 'ccpro/general/queueMonitoring/agentActivity:edit',
    },
    ACTION_CALL_OPTIONS: {
      CALL_RECORDINGS: {
        EDIT: 'ccpro/general/actionCallOptions/callRecordings:edit',
      },
      OUTBOUND_CALLS: {
        DID_CREATE: 'ccpro/general/actionCallOptions/outboundDIDCalls:create',
      },
    },
    FOLLOW_UPS: {
      ABANDONED_CALLS: {
        EDIT: 'ccpro/general/followUps/abandoned:edit',
      },
      SECOND_CHANCE_LEADS: {
        EDIT: 'ccpro/general/followUps/secondChanceLeads:edit',
      },
      VIRTUAL_AGENT: {
        EDIT: 'ccpro/general/followUps/virtualAgent:edit',
      },
      VOICEMAIL: {
        EDIT: 'ccpro/general/followUps/voicemail:edit',
      },
    },
  },
  manager: {
    CONVERSATION_DETAILS: {
      RECORDING_TRANSCRIPT_SECTION_VIEW: 'ccpro/general/callRecordings:view',
    },
    CONVERSATION_TRANSCRIPTS_AND_CALL_RECORDS_READ:
      'ccpro/general/conversations/transcripts:read',
    CONVERSATION_SENTIMENT: {
      VIEW_OWN: 'ccpro/general/conversations/AI:view',
      EDIT_ALL: 'ccpro/general/conversations/AI/analysis:edit',
    },
    CONVERSATION_OVERVIEW: {
      EDIT_OWN: 'ccpro/general/conversations/historical/user:edit',
      EDIT_ALL: 'ccpro/general/conversations/historical/all:edit',
    },
    MANAGER_ASSIST: {
      VIEW: 'ccpro/admin/managerAssist:view',
    },
  },
  admin: {
    RECORDING_SETTINGS: {
      EDIT: 'ccpro/admin/telecom/recordingSettings:edit',
    },
    VIRTUAL_AGENT: {
      EDIT: 'ccpro/admin/users/virtualAgents:edit',
    },
    TELECOM_WORKFLOWS: {
      LINES_AND_DEVICES: 'ccpro/admin/telecom/linesAndDevices:edit',
      VIEW: 'ccpro/admin/telecom/workflows:view',
      EDIT: 'ccpro/admin/telecom/workflows:edit',
    },
    USER_MANAGEMENT: {
      VIEW: 'ccpro/admin/users:view',
      QUEUES_EDIT: 'ccpro/admin/users/queues:edit',
      SEAT_LEVELS_EDIT: 'ccpro/admin/users/seatLevels:edit',
    },
    TELECOM_MANAGE_ACCOUNT: {
      EDIT_CALLER_ID: 'admin/telecom/outboundCallerIds:edit',
    },
    FEATURE_MANAGEMENT: {
      VIEW: 'ccpro/admin/featureManagement:view',
      CALL_ANALYSIS_EDIT: 'ccpro/admin/featureManagement/callAnalysis:edit',
      DATA_SHARING_EDIT: 'ccpro/admin/featureManagement/dataSharing:edit',
      INBOX_TASK_CARDS_EDIT: 'ccpro/admin/featureManagement/inboxTaskCard:edit',
    },
  },
} as const;

export const permissionSets = {
  general: {
    QUEUE_MONITORING: Object.values(permissions.general.QUEUE_MONITORING),
    FOLLOW_UPS: {
      ABANDONED_CALLS: Object.values(
        permissions.general.FOLLOW_UPS.ABANDONED_CALLS,
      ),
      SECOND_CHANCE_LEADS: Object.values(
        permissions.general.FOLLOW_UPS.SECOND_CHANCE_LEADS,
      ),
      VIRTUAL_AGENT: Object.values(
        permissions.general.FOLLOW_UPS.VIRTUAL_AGENT,
      ),
      VOICEMAIL: Object.values(permissions.general.FOLLOW_UPS.VOICEMAIL),
    },
  },
  manager: {
    CONVERSATION_SENTIMENT: Object.values(
      permissions.manager.CONVERSATION_SENTIMENT,
    ),
    MANAGER_ASSIST: Object.values(permissions.manager.MANAGER_ASSIST),
  },
  admin: {
    RECORDING_SETTINGS: Object.values(permissions.admin.RECORDING_SETTINGS),
    VIRTUAL_AGENT: Object.values(permissions.admin.VIRTUAL_AGENT),
    TELECOM_WORKFLOWS: Object.values(permissions.admin.TELECOM_WORKFLOWS),
    USER_MANAGEMENT: Object.values(permissions.admin.USER_MANAGEMENT),
    TELECOM_MANAGE_ACCOUNT: Object.values(
      permissions.admin.TELECOM_MANAGE_ACCOUNT,
    ),
    FEATURE_MANAGEMENT: Object.values(permissions.admin.FEATURE_MANAGEMENT),
    FEATURE_MANAGEMENT_CALL_ANALYSIS: [
      permissions.admin.FEATURE_MANAGEMENT.VIEW,
      permissions.admin.FEATURE_MANAGEMENT.CALL_ANALYSIS_EDIT,
    ],
    FEATURE_MANAGEMENT_DATA_INTEGRATION: [
      permissions.admin.FEATURE_MANAGEMENT.VIEW,
    ],
    ALL: [
      ...Object.values(permissions.admin.VIRTUAL_AGENT),
      ...Object.values(permissions.admin.TELECOM_WORKFLOWS),
      ...Object.values(permissions.admin.USER_MANAGEMENT),
      ...Object.values(permissions.admin.TELECOM_MANAGE_ACCOUNT),
      ...Object.values(permissions.admin.RECORDING_SETTINGS),
      ...Object.values(permissions.admin.FEATURE_MANAGEMENT),
    ],
  },
};
